import { useHotkeys } from 'react-hotkeys-hook';

import { KeyboardShortcut } from '@/Pages/KeyboardShortcutsSidePane';
import { emulateNativeClick } from '@/components/DataGrid.utils';
import { Tooltip } from '@/design-system';
import EditIcon from '@/icons/EditIcon.svg?react';
import TraceExpandIcon from '@/icons/TraceExpandIcon.svg?react';
import { RunSchema } from '@/types/schema';
import {
  appPublicDatasetsPath,
  appPublicPath,
  appRunPath,
  appSessionPath,
} from '@/utils/constants';
import { useClickLogger } from '@/utils/datadog/useClickLogger';
import { cn } from '@/utils/tailwind';

import { isRealRun } from '../utils/isRealRun';

export const DatasetSessionCompareRunActionButtons = (props: {
  run: RunSchema;
  datasetShareToken?: string;
  setDetailRunId: (runId: string) => void;
  setAnnotationDetailRunId: (runId: string) => void;
}) => {
  const logClick = useClickLogger();

  useHotkeys('a', () => {
    props.setAnnotationDetailRunId(props.run.id);
  });

  if (!isRealRun(props.run)) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex rounded-md border border-secondary bg-background p-1 transition-opacity'
      )}
    >
      {!props.datasetShareToken && (
        <Tooltip
          side="top"
          title={
            <div className="flex items-center">
              <span>Annotate</span>
              <KeyboardShortcut keys={['a']} />
            </div>
          }
        >
          <button
            type="button"
            className="flex h-6 w-6 items-center justify-center rounded hover:bg-tertiary active:bg-secondary group-hover:opacity-100"
            onClick={() => {
              props.setAnnotationDetailRunId(props.run.id);
            }}
          >
            <EditIcon className="h-4 w-4" />
          </button>
        </Tooltip>
      )}
      <Tooltip side="top" title="View trace">
        <button
          type="button"
          className="flex h-6 w-6 items-center justify-center rounded hover:bg-tertiary active:bg-secondary group-hover:opacity-100"
          onClick={(e) => {
            const targetUrl = props.datasetShareToken
              ? `/${appPublicPath}/${props.datasetShareToken}/${appPublicDatasetsPath}/${props.run.session_id}/${appSessionPath}/${appRunPath}/${props.run.id}?trace_id=${props.run?.trace_id}&start_time=${props.run?.start_time}`
              : props.run.app_path;

            logClick('open_trace_panel_button_detail_view', {
              runId: props.run.id,
              sessionId: props.run.session_id,
            });
            if (!emulateNativeClick(targetUrl, e.nativeEvent)) {
              props.setDetailRunId(props.run.id);
            }
          }}
        >
          <TraceExpandIcon className="h-5 w-5" />
        </button>
      </Tooltip>
    </div>
  );
};
